import repository from "./LeaveRepository"
import NewLeaveForm from "./LeavePrint"

import { Column, FilterRow,Lookup } from "devextreme-react/data-grid"
import DataGridView from "../../../Component/DataGridView"
import LookupEdit from "../../../Component/LookupEdit"
import { useState } from "react"
import { useEffectOnce } from "react-use"
import { SelectBox } from "devextreme-react/select-box"
import { CheckBox } from "devextreme-react/check-box"
import { useDate } from "../../../utils/DateHelper"
import { Popup } from "devextreme-react/popup"
import FileUploader from "devextreme-react/file-uploader"
import Cookies from "js-cookie"
import { baseUrl } from "../../../public/module/extra"
import http from "../../../network/HTTPClient"
import DateBox from "devextreme-react/date-box"
import ScrollView from "devextreme-react/scroll-view"

const LeavePage = (props) => {
    const [employees, setEmployees] = useState([])
    const [employeesActive, setEmployeesActive] = useState([])
    const [types, setTypes] = useState([])
    const [fineTypes, setfineTypes] = useState([])
    const [disableFine, setdisableFine] = useState(false)
    const [id, setId] = useState({})
    const [rowData, setRowData] = useState({})
    const [printLoad, setprintLoad] = useState(false)
    const [gbr, setGbr] = useState("")
    const [isPopupVisible, setisPopupVisible] = useState(false)
    const [isPopPrint, setisPopPrint] = useState(false)
    const { stringDate } = useDate(new Date(), "yyyy-MM-dd")
    useEffectOnce(async () => {
        const data = await repository.getEmployees()
        const dataType = await repository.getTypes()
        const dataActive = await repository.getEmployeesActive()
        const dataFineType = await repository.getFineTypes()
        setEmployees(data)
        setTypes(dataType)
        setfineTypes(dataFineType)
        setEmployeesActive(dataActive)
    })

    return (
        <>
            <DataGridView
                access={props.info.access}
                load={repository.all}
                insert={repository.insert}
                remove={repository.delete}
                update={repository.update}
                editingMode="form"
                onLoadComplete={(data) => {
                    return data
                }}
                onEditingStart={(e) => {
                    if(e.data.is_potong_gaji === 1){
                        setdisableFine(true)
                    }else{
                        setdisableFine(false)
                    }
                }}
            >
                <FilterRow visible={true} />
                <Column
                    width="200"
                    dataField="employee_id"
                    caption="Pegawai"
                    lookup={{
                        dataSource: employees,
                        displayExpr: "name",
                        valueExpr: "id"
                    }}
                    editCellRender={(cell) => (
                        <LookupEdit defaultValue={cell.value} dataSource={employeesActive} onValueChanged={(value) => cell.setValue(value)} />
                    )}
                    setCellValue={(newData, value, current) => {
                        newData.type = 0
                        newData.start_date = stringDate
                        newData.end_date = stringDate
                        newData.employee_id = value
                        //newData.is_deduction = 1;
                        //newData.is_potong_gaji = 0;
                    }}
                />
                <Column width="100" dataField="start_date" dataType="date" format="dd MMM yy" caption="Dari" />
                <Column width="100" dataField="end_date" dataType="date" format="dd MMM yy" caption="Sampai" />
                <Column
                    dataField="start_time"
                    dataType="string"
                    caption="Dari Jam"
                    editCellRender={(cell) => {
                        return (
                            <DateBox
                                defaultValue={cell.value}
                                type="time"
                                showClearButton={true}
                                pickerType="rollers"
                                displayFormat="HH:mm"
                                onValueChanged={({ value }) => cell.setValue(value)}
                            />
                        )
                    }}
                />
                <Column
                    dataField="end_time"
                    dataType="string"
                    caption="Sampai Jam"
                    editCellRender={(cell) => {
                        return (
                            <DateBox
                                defaultValue={cell.value}
                                type="time"
                                showClearButton={true}
                                pickerType="rollers"
                                displayFormat="HH:mm"
                                onValueChanged={({ value }) => cell.setValue(value)}
                            />
                        )
                    }}
                />
                <Column
                    dataField="type"
                    caption="Jenis"
                    lookup={{
                        dataSource: types,
                        displayExpr: "name",
                        valueExpr: "id"
                    }}
                    editCellRender={(cell) => {
                        return (
                            <SelectBox
                                defaultValue={cell.value}
                                items={types}
                                displayExpr="name"
                                valueExpr="id"
                                onValueChanged={({ value }) => cell.setValue(value)}
                            />
                        )
                    }}
                    setCellValue={(newData, value, current) => {
                        newData.type = value
                        //newData.is_deduction = 1;
                        //newData.is_potong_gaji = 0;
                    }}
                />
                <Column
                    allowFiltering={false}
                    width="auto"
                    alignment="center"
                    dataField="is_deduction"
                    caption="Potong Cuti"
                    dataType={"boolean"}
                    cellRender={(cell) => <CheckBox defaultValue={cell.value === 1 || cell.value === true ? true : false} readOnly={true} />}
                    setCellValue={(data, value, current, $) => {
                        // if (value) data.is_potong_gaji = false
                        $ = { new: data, value: value, old: current }
                        $.new.is_deduction = $.value
                        if ($.value) $.new.is_potong_gaji = false
                    }}
                    editCellRender={function (cell) {
                        return (
                            <CheckBox
                                defaultValue={cell.value === 1 || cell.value === true ? true : false}
                                //readOnly={cell.data.type === 0 ? true : false}
                                onValueChanged={({ value }) => cell.setValue(value)}
                            />
                        )
                    }}
                />
                <Column
                    allowFiltering={false}
                    width="auto"
                    alignment="center"
                    dataField="is_potong_gaji"
                    caption="Potong Gaji"
                    dataType={"boolean"}
                    cellRender={(cell) => <CheckBox defaultValue={cell.value === 1 || cell.value === true ? true : false} readOnly={true} />}
                    setCellValue={(data, value, current, $) => {
                        $ = { new: data, value: value, old: current }
                        $.new.is_potong_gaji = $.value
                        if ($.value) $.new.is_deduction = false
                    }}
                    editCellRender={(cell) => {
                        return (
                            <CheckBox
                                defaultValue={cell.value === 1 || cell.value === true ? true : false}
                                onValueChanged={({ value }) => {
                                    cell.setValue(value);
                                    value === 1 || value === true ? setdisableFine(true) : setdisableFine(false);
                                }}
                            />
                        )
                    }}
                />
                <Column
                    allowFiltering={false}
                    width="50%"
                    alignment="center"
                    dataField="fine_id"
                    caption="Jenis Potongan"
                    allowEditing={disableFine}
                >
                    <Lookup
                        dataSource={fineTypes}
                        displayExpr="name"
                        valueExpr="id"
                    />
                </Column>
                <Column dataField="desc" caption="Keterangan" />
                <Column
                    type="buttons"
                    width={110}
                    buttons={[
                        { name: "edit" },
                        { name: "delete" },
                        {
                            icon: "user",
                            visible: true,
                            onClick: (e) => {
                                setId({ id: e.row.data.id })
                                http.post("/leave/upload/get", { id: e.row.data.id }).then((response) => {
                                    setGbr(response.data.img)
                                    setisPopupVisible(true)
                                })
                            }
                        },
                        {
                            icon: "print",
                            hint: "Print",
                            visible: props.info.access.includes("print"),
                            onClick: (e) => {
                                setprintLoad(true)
                                setRowData({ rowData: e.row.data })
                                setisPopPrint(true)
                                setprintLoad(false)
                            }
                        }
                    ]}
                />
            </DataGridView>

            <Popup
                showTitle={true}
                title={"View Print"}
                visible={isPopPrint}
                closeOnOutsideClick={false}
                onHiding={() => setisPopPrint(false)}
                dragEnabled={false}
            >
                <ScrollView>
                    <NewLeaveForm rowData={rowData} formLoad={printLoad} />
                </ScrollView>
            </Popup>
            <Popup
                showTitle={true}
                title={"Upload Bukti Ijin/Cuti/Sakit"}
                visible={isPopupVisible}
                closeOnOutsideClick={false}
                onHiding={() => setisPopupVisible(false)}
                dragEnabled={false}
            >
                <FileUploader
                    multiple={false}
                    selectButtonText="Pilih Gambar"
                    accept="image/*"
                    uploadMode="useButtons"
                    uploadUrl={baseUrl + "leave/upload"}
                    uploadHeaders={{
                        Authorization: `Bearer ${Cookies.get("token")}`
                    }}
                    uploadCustomData={id}
                />
                {gbr !== "" ? (
                    <>
                        <br />
                        <img src={"data:image/png;base64," + gbr} alt={"Bukti Ijin"} style={{ height: 150, width: null, flex: 1 }} />
                    </>
                ) : null}
            </Popup>
        </>
    )
}

export default LeavePage
